import http from 'common-module/src/util/http';

/* 获取产品价格方案 */
export const getProductScheme = (data) => http.post('/product/get/scheme', data);

/* 产品试用接口 */
export const productTrial = (data) => http.post('/product-order/free/trial', data);


/**
 * stripe产品列表
*/
export const loadProjectSchemes = () => http.post('/product-scheme/product-schemes');

// 获取权益项展示顺序及是否显示
export const loadSchemesCode = () => http.post('/product-scheme/rule-codes');

/** 查询指定产品详情
 *  @param schemeId 版本id
*/
export const loadProjectSchemeDetail = (data) => http.get('/product-scheme/scheme-detail', data);

/* stripe产品升级降级获取详情 */
export const loadSchemeChangeDetails = (data) => http.post('/product-scheme/scheme-change-details', data);

/** Stripe查询账单需要支付金额
 *  @param data Stripe订阅订单商品项列表
 */
export const getPriceForUpdateSubscription = (data) => http.post('/stripe-pay/query-price-for-update-subscription', data);

/**
 * Stripe订阅后查询价格及发票等信息
 * @param subscriptionId stripe订阅id
 * */
export const getSubscriptionLastInvoice = (subscriptionId) => http.post('/stripe-order/query-subscription-last-invoice', { subscriptionId });

/* 获取用户stripe支付基础信息 */
export const loadUserCustomer = () => http.post('/stripe-pay/get-customer');

/* 添加用户stripe支付基础信息 */
export const addUserCustomer = (data) => http.post('/stripe-pay/add-customer', data);

/* 创建订阅订单 */
export const createSubscriptionOrder = (data) => http.post('/stripe-pay/create-subscription-order', data);

/* 更新订阅 */
export const updateSubscriptionOrder = (data) => http.post('/stripe-pay/update-subscription-order', data);

/* 查询当前订单信息 */
export const getSubscriptionOrder = (data) => http.post('/stripe-order/query-current-subscription', data);

/* 取消未支付订单 */
export const cancelSubscriptionOrder = (data) => http.post('/stripe-pay/cancel-subscription-order', data);

/* 获取stripe公钥 */
export const getStripeConfig = () => http.post('/stripe-pay/get-config');

export const getPayInfo = (orderNumber) => http.get('/domestic-pay/get-pay-code', { orderNum: orderNumber });
export const getPaymentStatus = (orderNumber) => http.get('/domestic-pay/get-pay-status', { orderNum: orderNumber });
export const getOfflinePayInfo = () => http.post('/pay-order/get-pay-info', {});

// 国内版获取当前使用的版本对象信息
export const getCurrentScheme = () => http.post('/pay-order/query-current-scheme');

// 国内版初次购买权益，查询需要订单需要支付的金额
export const getPriceForBuy = (data) => http.post('/pay-order/query-price-for-buy', data);

// 国内版升级权益，查询需要订单需要支付的金额
export const getPriceForUpgrade = (data) => http.post('/pay-order/query-price-for-upgrade', data);

// 国内版初次购买权益下单
export const createOrder = (data) => http.post('/pay-order/buy-product-right', data);

// 国内版升级权益，查询需要订单需要支付的金额
export const upgradeProductRight = (data) => http.post('/pay-order/upgrade-product-right', data);

// 国内版查询订单详情
export const queryOrderDetail = (data) => http.post('/pay-order/query-order-detail', data);

export const orderBindPayChannel = (data) => http.post('/pay-order/bind-pay-channel', data);

// 国内版下载订单支付凭证
export const getDownloadBill = (orderNumber) => http.post(`/pay-order/download-bill/${orderNumber}`, { orderNumber }, {
  responseType: 'blob',
  assertResult: (response, data) => {
    response.data = { result: data };
    return true;
  }
});

// 国内版查询最后一笔权益订单详情
export const queryLastOrderDetail = (data) => http.post('/pay-order/query-last-order-detail', data);

/**
 * 取消订单
 * @param data
 * @returns {}
 */
export const cancelOrder = (data) => http.post('/pay-order/cancel-order', data);

/* 回退版本 */
// 查询组织权益使用情况明细数据(版本过期也返回)
export const getUsedRightDetail = (data = {}) => http.post('/right-reduce/right-used-detail  ', data);

// 查询最近一次回退到免费版操作记录
export const queryBackScheme = (data = {}) => http.post('/right-reduce/query-back-scheme', data, {
  showError: false
});

// 立即回退到免费版
export const backScheme = (data = {}) => http.post('/right-reduce/back-scheme', data);

// 到期回退到免费版
export const expireBackScheme = (data = {}) => http.post('/right-reduce/expire-back-scheme', data);

// 取消回退到免费版
export const cancelBackScheme = (data = {}) => http.post('/right-reduce/cancel-back-scheme', data);

// 查询组织成员列表（用于回退版本移除成员选择）
export const queryOrgUsers = (data = {}) => http.post('/right-reduce/query-org-users', data);

// 海外版试用立即回退到免费版
export const trialBackScheme = (data = {}) => http.post('/right-reduce/back-us-free-scheme', data);


/* 取消订阅 */
// Stripe设置订阅到期取消
export const cancelSubscription = (data = {}) => http.post('/stripe-pay/cancel-subscription-period-end', data);

// Stripe恢复订阅
export const recoverySubscription = (data = {}) => http.post('/stripe-pay/recovery-subscription', data);

/**
 * 释放已使用的超量资源(组织版本已经回退到免费版)
 * @param data
 * userIds -> Array
*/
export const releaseResources = (data = {}) => http.post('/right-reduce/release-resources', data);

/**
 * 获取组织当前的某项权益
 * @param {string} rightType
*/
export const queryOrgRightRule = (data = {}) => http.post('/product/get/product-rule', data);

/**
 * 查询组织当前的某项权益是否可用
 * @param {string} rightType
*/
export const checkEightExisted = (data = {}) => http.post('/product/check-right-existed', data);
